// import React from "react";
// import { Avatar, InfoCircle } from "../../../../../components";
// import pic from "../../../../../assets/images/profile-dummy.png";

// const AvatarList = () => {
//   const sizes = ["md"];
//   const colors = ["primary"];
//   const colorsDepth = [
//     "50",
//     "100",
//     "200",
//     "300",
//     "400",
//     "500",
//     "600",
//     "700",
//     "800",
//     "900",
//   ];

//   return (
//     <div className="my-5 flex flex-col gap-2">
//       <div className="flex gap-2 items-center flex-wrap">
//         {colors.map((color) =>
//           colorsDepth.map((depth) => {
//             return (
//               <div className="flex items-center gap-2">
//                 {sizes.map((size) => (
//                   <Avatar
//                     key={`${size}-${color}-${depth}`}
//                     alt="Ershad Mohammad"
//                     // src={pic}
//                     size={size}
//                     color={color}
//                     colorDepth={depth}
//                   />
//                 ))}
//               </div>
//             );
//           })
//         )}
//       </div>
//       <div className="flex gap-2 items-center flex-wrap">
//         {colors.map((color) =>
//           colorsDepth.map((depth) => {
//             return (
//               <div className="flex items-center gap-2">
//                 {sizes.map((size) => (
//                   <Avatar
//                     key={`${size}-${color}-${depth}`}
//                     alt="Ershad Mohammad"
//                     src={pic}
//                     size={size}
//                     color={color}
//                     colorDepth={depth}
//                     showInitials
//                   />
//                 ))}
//               </div>
//             );
//           })
//         )}
//       </div>
//       <div className="flex gap-2 items-center flex-wrap">
//         {colors.map((color) =>
//           colorsDepth.map((depth) => {
//             return (
//               <div className="flex items-center gap-2">
//                 {sizes.map((size) => (
//                   <Avatar
//                     key={`${size}-${color}-${depth}`}
//                     alt="Ershad Mohammad"
//                     // src={pic}
//                     size={size}
//                     color={color}
//                     colorDepth={depth}
//                     showInitials
//                     variant="outlined"
//                   />
//                 ))}
//               </div>
//             );
//           })
//         )}
//       </div>

//       <div className="flex gap-2 items-center">
//         {sizes.map((size) => (
//           <div key={size}>
//             <Avatar key={size} alt={"Ershad Mohammad"} src={pic} size={size} />
//           </div>
//         ))}
//       </div>
//       <div className="flex gap-2 items-center">
//         {sizes.map((size) => (
//           <div key={size}>
//             <InfoCircle value="+9" size={size} />
//           </div>
//         ))}
//       </div>

//       {/* <Avatar alt={"Ershad Mohammad"} />
//       <Avatar alt={"Ershad Mohammad"} showInitials />
//       <Avatar alt={"Ershad Mohammad"} showInitials src={pic} /> */}
//     </div>
//   );
// };

// export default AvatarList;

import React from "react";
import { Avatar, InfoCircle } from "../../../../../components";
import pic from "../../../../../assets/images/profile-dummy.png";

const AvatarList = () => {
  const sizeList = [
    "xs",
    "xs-sm",
    "sm",
    "md",
    "lg",
    "xl",
    "xxl",
    "3xl",
    "4xl",
    "5xl",
  ];
  const colorList = [
    "primary",
    "warning",
    "success",
    "danger",
    "info",
    "draft",
    "invoiced",
    "leave",
  ];
  const colorDepthList = [
    "50",
    "100",
    "200",
    "300",
    "400",
    "500",
    "600",
    "700",
    "800",
    "900",
  ];
  const variantList = ["contained", "outlined"];
  const noBorderList = [true, false];

  return (
    <div className="w-full my-4 flex flex-col gap-3">
      <div className="flex gap-2 items-center flex-wrap">
        {sizeList.map((size) => (
          <div key={size}>
            <Avatar
              key={size}
              alt={"Ershad Mohammad"}
              size={size}
              showInitials
            />
          </div>
        ))}
      </div>
      <div className="flex gap-2 items-center flex-wrap">
        {sizeList.map((size) => (
          <div key={size}>
            <Avatar
              key={size}
              alt={"Ershad Mohammad"}
              size={size}
              showInitials
              src={pic}
              color="info"
            />
          </div>
        ))}
      </div>
      <div className="flex gap-2 items-center flex-wrap">
        {colorList.map((color) => {
          return (
            <div key={color} className="flex gap-1">
              {colorDepthList.map((depth) => {
                return (
                  <div key={depth} className="flex gap-1">
                    <Avatar
                      key={`${color}-${depth}`}
                      alt="Ershad Mohammad"
                      color={color}
                      colorDepth={depth}
                      showInitials
                    />
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
      <div className="flex flex-col gap-2">
        {variantList.map((variant) => {
          return (
            <div key={variant} className="flex gap-2">
              {colorList.map((color) => {
                return (
                  <div key={color} className="flex gap-2">
                    <Avatar
                      key={`${variant}-${color}`}
                      alt="Ershad Mohammad"
                      color={color}
                      variant={variant}
                      showInitials
                    />
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
      <div>
        {noBorderList.map((noBorder) => {
          return (
            <div key={noBorder} className="flex gap-2">
              <Avatar
                key={`${noBorder}`}
                alt="Ershad Mohammad"
                showInitials
                noBorder={noBorder}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AvatarList;
